import { render, staticRenderFns } from "./addModel.vue?vue&type=template&id=2b6b4720&scoped=true&"
import script from "./addModel.vue?vue&type=script&lang=js&"
export * from "./addModel.vue?vue&type=script&lang=js&"
import style0 from "./addModel.vue?vue&type=style&index=0&id=2b6b4720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b4720",
  null
  
)

export default component.exports